import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import HelpIcon from '@mui/icons-material/Help';
import Parser from 'html-react-parser';
import {
    Typography,
    Button,
    useMediaQuery,useTheme
} from '@mui/material'

import { fileActions} from '../../store/actions'
import { groupActorsFunctions } from './GroupActorsFunctions'
import { coreFunctions } from '../../utils'
//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './GroupActorsStyles.js'
import {
    UseImage,InputField,
    CustomAlertHelpDialog,
    ListElement,
    CustomAlertMaterial, CustomLoadingOverlay, CustomAlertDialog, CustomMainContainer
,Buttons,LinkButton } from '../../components'

import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"
import { useTranslation } from 'react-i18next';

export default function GroupActorsComponent(props) {

    const matches = useMediaQuery('(max-width:812px)')
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [openHelp, setOpenHelp] = useState(true)
    const [openAlert, setOpenAlert] = useState(false)
    const [openAlertCreate, setOpenAlertCreate] = useState(false)
    const [isNewGroup, setIsNewGroup] = useState(false)
    const [groupName, setGroupName] = useState('')
    const [actorOptions, setActorOptions] = useState([])
    const [currentActors, setCurrentActors] = useState([])
    const [actorId, setActorId] = useState(0)
    const [rol, setRol] = useState('')
    const [saveGroupName, setSaveGroupName] = useState(false)
    const [folioId, setFolioId] = useState(0)
    const [showName, setShowName] = useState(false)
    const [statusProcess, setStatusProcess] = useState(false)
    const [sendFinalize, setSendFinalize] = useState(false)
    const [registerNewActor, setRegisterNewActor] = useState(false)
    const [loadInit, setLoadInit] = useState(false)
    const [startActorFlow, setStartActorFlow] = useState(false)

    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [openErrorTitle, setOpenErrorTitle] = useState("");
    const [openErrorDescription, setOpenErrorDescription] = useState("");

    const [errorNameGroup, setErrorNameGroup] = useState(true)
    const [errorNameGroupDesc, setErrorNameGroupDesc] = useState("")
    const [saveCreateActor, setSaveCreateActor] = useState(false)
    const [initProcess, setInitProcess] = useState(false)

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    const file = useSelector(state => state.FileInfo)
    const auth = useSelector(state => state.Authentication)
    const actorsInfo = useSelector(state => state.Actors)
    const newActor = useSelector(state => state.NewActor)
    const startFlow = useSelector(state => state.StartActor)
    const nameGroupData = useSelector(state => state.GroupNameData)
    const contStageActorSelect = useSelector(state => state.ContinueStageActorSelect)
    const { t } = useTranslation();

    useEffect(() => {
        // console.log("location.state.searchFiles--------------------------------: ", location.state.searchFiles)
        setFolioId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setLoadInit(true)
        sessionStorage.setItem('isFlowGroup', true)
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && registerNewActor) {
            // console.log("file.items------------GET ACTORE New REGISTER-----------------------: ", file.items)
            const optionsJson = file.items.Stage?.Properties?.find((prop) => prop.Name === 'ConfigurationOptions')
            setActorOptions(JSON.parse(optionsJson?.Value))
            dispatch(fileActions.GetActors(folioId))
            setSaveCreateActor(true)
        }
        else if (loadInit && file.items != undefined) {
            // console.log("file.items------------INIT-----------------------: ", file.items)
            setLoadInit(false)
            if (file.items?.Stage != undefined && file.items?.Stage?.Properties.length > 0) {
                const optionsJson = file.items.Stage?.Properties?.find((prop) => prop.Name === 'ConfigurationOptions')
                if (optionsJson?.Value != undefined && optionsJson?.Value != null && optionsJson?.Value != "") {
                    setActorOptions(JSON.parse(optionsJson?.Value))
                    console.log(JSON.parse(optionsJson?.Value))
                }
                dispatch(fileActions.GetActors(folioId))
                setSaveCreateActor(true)
            }
            if (file.items?.Metadata != undefined && file.items?.Metadata.length > 0) {
                const ifgroupName = file.items.Metadata.filter((data) => data.GroupName === 'Grupo' && data.Name === 'Nombre')
                if (ifgroupName.length > 0) {
                    setGroupName(ifgroupName[0].Value)
                    setShowName(false)
                } else {
                    setGroupName('')
                    setShowName(true)
                }
            }
        }
        else if ((loadInit || registerNewActor) && file.error != undefined) {
            setLoadInit(false)
            alert(file.error)
        }
    }, [file])

    useEffect(() => {
        setLoadView(actorsInfo.loading)
        if (actorsInfo.items != undefined && saveCreateActor) {
            setLoadView(false)
            // console.log("actorsInfo.items.length----------------------------: ", actorsInfo.items.length)
            // console.log("actorsInfo.items----------------------------: ", actorsInfo.items)
            if (actorsInfo.items.length > 0) {
                setCurrentActors(actorsInfo.items)
            }
        }
        if (actorsInfo.error != undefined && saveCreateActor) {
            setLoadView(false)
            setSaveCreateActor(false)
            alert("Ocurrio un error: " + actorsInfo.error)
        }
    }, [actorsInfo])

    useEffect(() => {
        const newOptions = actorOptions.filter((el) => !currentActors.some((element) => element.TypeName === el.TypeName) || el.MaximumNumberAllowed === -1)
        // console.log('newoptions', newOptions)
        setActorOptions(newOptions)
    }, [currentActors])

    useEffect(() => {
        setLoadView(newActor.loading)
        if (newActor.items != undefined && registerNewActor) {
            console.log("newActor.items--------------------------------------------: ", newActor.items)
            setActorId(newActor.items.Id)
            setRol(newActor.items.TypeName)
            // dispatch(fileActions.GetFileInfo(folioId))
        }
    }, [newActor])

    useEffect(() => {
        setLoadView(startFlow.loading)
        if (startFlow.items != undefined && startActorFlow) {
            // console.log("startFlow.items--------------------------------------------: ", startFlow.items)
            if (startFlow.items.Result && startFlow.items.Stage != null) {
                setStartActorFlow(false)
                const stageName = startFlow.items.Stage.Name
                const nextComponent = coreFunctions.GetLegoNext(stageName)
                console.log("Entro en stage-----------------------------: ", nextComponent)
                groupActorsFunctions.nextStage({ stageName, nextComponent, auth ,navigate,folioId, actorId })
            }
        } else if (startFlow.error != undefined && loadView) {
            alert(startFlow.error)
        }
    }, [startFlow])

    useEffect(() => {
        if (nameGroupData.items != undefined && saveGroupName) {
            setLoadView(false)
            setSaveGroupName(false)
            if (isNewGroup) {
                const requestReg = {
                    File_Id: folioId,
                    TypeName: rol
                }
                // console.log("requestReg----------------------------: ", requestReg)
                dispatch(fileActions.RegisterActor(requestReg))
                setLoadView(true)
                setSaveCreateActor(true)
                setInitProcess(true)
                setIsNewGroup(false)
                setRegisterNewActor(true)
            }
        }
        if (nameGroupData.error != undefined && saveGroupName) {
            setLoadView(false)
            alert("Ocurrio un error: " + nameGroupData.error)
        }
    }, [nameGroupData])

    useEffect(() => {
        if (actorId > 0 && initProcess) {
            setInitProcess(false)
            startProcess()
        }
    }, [actorId])

    useEffect(() => {
        if (contStageActorSelect.items != undefined && sendFinalize) {
            setLoadView(false)
            // console.log("Entro en finalize.......................Entro----: ")
            const stageName = startFlow.items?.Stage?.Name
            const nextComponent = coreFunctions.GetLegoNext(stageName)
            groupActorsFunctions.nextStage({ stageName, nextComponent, auth ,navigate,folioId, actorId })
        }
        if (contStageActorSelect.error != undefined && sendFinalize) {
            setLoadView(false)
            alert("Ocurrio un error: " + contStageActorSelect.error)
        }
    }, [contStageActorSelect])

    const openAlertProcess = (name, id, status) => {
        // console.log(" openAlertProcess = (name, id, status)--------: ", name, id, status)
        setOpenAlert(true)
        setActorId(id)
        setRol(name)
        setStatusProcess(status)
        console.log('id de actor', id)
    }

    const createActor = () => {
        if (groupName === null || groupName === undefined || groupName == "") {
            setErrorNameGroup(true)
            setErrorNameGroupDesc("Ingrese el nombre de grupo")
            setOpenAlertCreate(false)
        } else {
            if (groupName != null && groupName != undefined && groupName != "" && !isNewGroup) {
                const requestReg = {
                    File_Id: folioId,
                    TypeName: rol
                }
                // console.log("requestReg------------Create Aactor----------------: ", requestReg)
                dispatch(fileActions.RegisterActor(requestReg))
                setLoadView(true)
                setSaveCreateActor(true)
                setInitProcess(true)
                setOpenAlertCreate(false)
                setRegisterNewActor(true)
            } else if (isNewGroup) {
                let requestGroup = {
                    File_Id: folioId,
                    GroupName: groupName
                }
                // console.log("requestGroup------------Create Group----------------: ", requestGroup)
                dispatch(fileActions.SetGroupName(requestGroup))
                setLoadView(true)
                setSaveGroupName(true)
                setOpenAlertCreate(false)
            }
        }
    }

    const startProcess = () => {
        if (statusProcess == "Actors Complete") {
            setOpenAlert(false)
            setOpenErrorAlert(true)
            setOpenErrorDescription("El actor ya completo el flujo actual")
            setOpenErrorTitle("Advertencia")
        } else {
            dispatch(fileActions.StartActorFlow(actorId))
            setStartActorFlow(true)
            setOpenAlert(false)
        }
    }

    const closeAlertProcess = () => {
        setOpenAlert(false)
        setOpenAlertCreate(false)
        setActorId(0)
        setRol('')
    }

    const handleSend = () => {
        if (actorsInfo.items.length > 0) {
            dispatch(fileActions.ContinueStageActorSelection(folioId))
            setSendFinalize(true)
            setLoadView(true)
        } else {
            alert("Debe tener al menos un actor para continuar.")
        }
    }

    const editRoles = () => {
        const nextComponent = 'EditActorsComponent'
        groupActorsFunctions.nextStage({ nextComponent, auth ,navigate,folioId, actorId })
    }

    const handleCloseErrorAlert = () => {
        setOpenErrorAlert(false)
    };

    const editGroupInstructions = 'Inicia proceso de captura, agrega o edita roles de integrantes y cancela solicitudes.'

    //For the slides inside help 
    let list = [
        {
            key: '1',
            component: <WizardComponent
                title='Iniciar proceso de integrante'
                description='Recuerda que puedes editar el proceso de un usuario previamente registrado, para iniciar o completar el registro haz clic sobre el rol a editar.'
                image={matches ? 'Iniciar_proceso.gif' : 'Cancelar_solicitud_desk.gif'} />
        },
        {
            key: '2',
            component: <WizardComponent
                title='Enviar solicitud'
                description='Para enviar una solicitud, primero debes completar la carga de documentos por rol, y estos debe ser validados para continuar.'
                image={matches ? 'Enviar_solicitud.gif' : 'Cancelar_solicitud_desk.gif'} />
        },
        {
            key: '3',
            component: <WizardComponent
                title='Editar integrante'
                description='Para eliminar deberás acceder a "Editar Roles" y eliminar al integrante. Te recordamos que esta acción no se podrá revertir.'
                image={matches ? 'Cancelar_solicitud.gif' : 'Cancelar_solicitud_desk.gif'} />
        }
        // {
        //     key: '4',
        //     component: <WizardComponent
        //         title='Eliminar integrante'
        //         description='Para eliminar deberás acceder a "Editar Roles" y eliminar al integrante. Te recordamos que esta acción no se podrá revertir.'
        //         image='Cancelar_solicitud.gif' />
        // }
    ]

    return (<CustomMainContainer
        oneButton={true}
        body={<div>
            <Typography
                variant="subtitle1" gutterBottom>Selecciona el integrante con el que deseas inciar el proceso.
                <HelpIcon style={{ marginLeft: 7 }} onClick={() => { setOpenHelp(true) }} />
            </Typography>

            {showName &&
                <InputField
                    fullWidth
                    size="small"
                    type='Text'
                    textTransform='none'
                    value={groupName}
                    variant='outlined'
                    className={localStyles.nameInput}
                    onChange={(e) => {
                        setGroupName(e.target.value)
                        if (showName) {
                            setIsNewGroup(true)
                        }
                        if (e.target.value == "") {
                            setErrorNameGroup(true)
                            setErrorNameGroupDesc("Ingrese el nombre de grupo")
                        } else {
                            setErrorNameGroup(false)
                            setErrorNameGroupDesc("")
                        }
                    }}
                    error={errorNameGroup}
                    helperText={errorNameGroupDesc}
                    label='Nombre de grupo' />
            }
            <div className={localStyles.actorsSections}>
                {currentActors.map((actor) => {
                    return <Button
                        className={gridContainer.buttonList}
                        key={actor.Name}
                        onClick={() => openAlertProcess(actor.TypeName, actor.Id, actor.Status)}
                    >
                        <ListElement
                            text={actor.TypeName}
                            icon={actor.Icon}
                            description={actor.Name != null && `${actor.Name} ${actor.FatherLastName} ${actor.MotherLastName}`}
                        />
                    </Button>
                })}
            </div>

            <div className={localStyles.newActorsSections}>
                {actorOptions.map((option) => {
                    return <Button
                        className={gridContainer.buttonList}
                        key={option.TypeName}
                        onClick={() => {
                            // createActor(option.TypeName)
                            // console.log("select values------------------: ", option.TypeName, option)
                            setRol(option.TypeName)
                            setOpenAlertCreate(true)
                        }} >
                        <ListElement
                            text={`${option.TypeName}`}
                            icon={option.Icon}
                            newItem={true}
                        />
                    </Button>
                })}
            </div>

            <LinkButton LinkButtonText="name button" LinkButtonUrl=""
                text_size={12}
                text_color={theme.palette.primary.main}
                text='Editar roles'
                type='button'
                size={100}
                click={editRoles}
                className={localStyles.editText}
            />



        </div>}
        buttons={<div>
            <Buttons
                text_color="#FFFFFF"
                // background_color={theme.palette.primary.main}
                // border_color={theme.palette.primary.main}
                size={100}
                className={currentActors?.length > 1 ? localStyles.continueBtn : localStyles.continueBtnDisabled}
                background_color={currentActors?.length > 1 ? theme.palette.button.main : '#DFDFDF'}
                text="Enviar"
                type="button"
                click={handleSend}
            />
        </div>}
        externals={<div>
            {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
            <CustomAlertMaterial
                title='Proceso'
                body={Parser(`Estas a punto de iniciar el proceso para el rol de <b>${rol}</b> ¿Deseas continuar?`)}
                closeAction={closeAlertProcess}
                open={openAlert}
                leftButtonText='Cancelar'
                leftButtonAction={closeAlertProcess}
                rightButtonText={t("general_accept")}
                rightButtonAction={startProcess}
            />

            <CustomAlertMaterial
                title='Proceso'
                body={Parser(`Estas a punto de iniciar el proceso para el rol de <b>${rol}</b> ¿Deseas continuar?`)}
                closeAction={closeAlertProcess}
                open={openAlertCreate}
                leftButtonText='Cancelar'
                leftButtonAction={closeAlertProcess}
                rightButtonText={t("general_accept")}
                rightButtonAction={createActor}
            />

            <CustomAlertHelpDialog
                closeAction={() => { setOpenHelp(false) }}
                open={openHelp}
                body={
                    <div ref={ref} className={localStyles.wizardContainer}>
                        {list.map(item => (
                            <div key={item.key}>{item.component}</div>
                        ))}
                    </div>
                }
            />

            <CustomAlertDialog open={openErrorAlert}
                closeAction={handleCloseErrorAlert}
                title={openErrorTitle}
                textDescription={openErrorDescription}
                textAcepted={t("general_accept")}
                aceptedAction={handleCloseErrorAlert}
            />
        </div>}
    />
    )

}

function WizardComponent(props) {
    const localStyles = {}//useStyles()

    return (
        <div key={1} >
            <div className={localStyles.carouselSection}>
                <div className={localStyles.textContent}>
                    <Typography
                        variant="h6"
                        gutterBottom>
                        {props.title}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom>
                        {props.description}
                    </Typography>
                </div>
                <UseImage className={localStyles.helpImage} src={props.image} />
            </div>
        </div>
    )
}